"use client";
import o from "styled-components";
const a = o.div`
  background-color: #bad7f6;
  border: 1px solid #1a1a1a;
  width: 16px;
  height: 16px;
  transform: rotate(45deg);
`;
export {
  a as default
};
//# sourceMappingURL=index.es156.js.map
